define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/StorageUtil',
	
	'model/Error',
	'model/ErrorType',
	
	'state/UIState',
	
	'service/UIStateManager',
	
	'view/SplashScreenView',
	'view/TimeoutErrorView',
	'view/ControlBarView',
        'view/TextView',
	
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/RequestAccessState_strings'
], function (
	Logger,
	Util,
	StorageUtil,
	
	Error,
	ErrorType,
	
	UIState,
	
	UIStateManager,
	
	SplashScreenView,
	ErrorView,
	ControlBarView,
        TextView,
	
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * ErrorState class
	 */
	function ErrorState(uiStateManager) {
		var _uiStateManager,
			_splashScreenView = new SplashScreenView(),
			_controlBarView = new ControlBarView('skIdS_control-bar-error'),
			_nextButton,
			_nextCallback;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

//		_splashScreenView.disableAnimation();
		
		_controlBarView.addButton(Strings.abort, function () {
                        StorageUtil.remove("cached_referrer");
			window.close();
		},0);
		
		var _confirmButton = _controlBarView.addButton(Strings.ok, function () {
                    var ref = getReferrer().split("/");
                    var origin = ref[0] + "//" + ref[2];

                    var origins = StorageUtil.read("api_allowed_origins");
                    
                    if (origins === null) {
                        origins = [];
                    }
                    
                    for (var i = 0; i < origins.length; i++) {
                        if (origins[i] === origin) {
                            //Origin is already allowed
                            StorageUtil.remove("cached_referrer");
                            window.close();
                        }
                    }
                    
                    origins.push(origin);
                    StorageUtil.store("api_allowed_origins", origins, false);
                    StorageUtil.remove("cached_referrer");
                    window.close();
		},2);


		UIState.call(this, 'request_access');
                
                var _instructionsView = (function () {
                            var textView = new TextView();

                            textView.addText(Strings.requestIntro);
                            textView.addNewLine(2);
                            textView.addText(getReferrer());
                            textView.addNewLine(2);
                            textView.addText(Strings.requestIntroConfirm);

                            return textView;
                    })();

                    
                function getReferrer() {
                    var ref = document.referrer;
                    var cRef = StorageUtil.read("cached_referrer");
                    
                    if (cRef !== null) {
                        ref = cRef;
                    } else {
                        StorageUtil.store("cached_referrer", ref, true);
                    }
                    
                    return ref;
                }

		// public methods

		this.title = function () {
			return Strings.RequestAccess;
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _splashScreenView, _instructionsView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

//var win = window.open("https://dev.skidentity.de/ids-api/request_access.html",'popup','width=650,height=500')
		this.enter = function (doneCallback, error) {
                    if (document.referrer === "") {
                        _confirmButton.hide();
                        _instructionsView = (function () {
                            var textView = new TextView();

                            textView.addText(Strings.requestNoReferrer);

                            return textView;
                        })();
                    }

			Util.callCallbacks(doneCallback);
		};

		this.leave = function (doneCallback) {

			Util.callCallbacks(doneCallback);
		};
	};

	ErrorState.prototype = Object.create(UIState.prototype);

	return ErrorState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/RequestAccessState.js
// module id = 364
// module chunks = 2